import PaymentSuccessful from "../../assets/images/PaymentIcons/PaymentSuccessful.gif";
import LottieAnimation from "../public/SuccessAnimation";

export const PurchaseSuccess = ({ button, onclick, title, des }) => {
  return (
    <div className="w-[400px] flex flex-col items-center py-10 relative pb-5">
      <div className="mx-auto sm:w-[300px]">
        <LottieAnimation />
      </div>
      <h2 className="w-[350px] text-f20 font-extrabold">{title}</h2>
      <p className="w-[350px] text-secondary pt-2 pb-4 w-80 text-f14">{des}</p>
      <hr />
      <button
        onClick={onclick}
        className="bg-primary px-4 py-2 text-white text-f14 rounded w-full"
      >
        {button}
      </button>
    </div>
  );
};
